type Section =
    | string
    | {
          id: string;
          slug: string;
      };

const ProjectHelpers = {
    swr: {
        recentProjects: () => '/projects/recent',
        users: (projectId: string) => `/projects/${projectId}/users`,
    },

    defaults: {
        name: '[untitled project]',
    },

    urls: {
        overview: () => '/projects',
        supportProjects: () => '/projects#support-projects',
        create: (
            options: {
                name?: string;
                isReferenceDesign?: boolean;
                manufacturer?: string;
                referenceComponent?: string;
            } = {
                name: '',
                isReferenceDesign: false,
                manufacturer: '',
                referenceComponent: '',
            },
        ) => {
            const { name = '', manufacturer = '', isReferenceDesign = false, referenceComponent = '' } = options;

            const query = [];

            if (name) {
                query.push(`name=${name}`);
            }

            if (isReferenceDesign) {
                query.push('isReferenceDesign=true');
            }

            if (manufacturer) {
                query.push(`manufacturer=${manufacturer}`);
            }

            if (referenceComponent) {
                query.push(`referenceComponent=${referenceComponent}`);
            }

            return `/projects/create${query.length ? `?${query.join('&')}` : ''}`;
        },
        edit: (projectId: string) => `/projects/${projectId}`,
        editor: (ids: string, action?: 'publish') => {
            return action ? `/projects/${ids}/editor?action=${action}` : `/projects/${ids}/editor`;
        },
        duplicate: (projectId: string, name: string, isReferenceDesign: boolean) =>
            `/projects/create?startFromExistingProject=${projectId}&name=${name}&isReferenceDesign=${isReferenceDesign}`,
        requestAccess: (projectId: string) => `/projects/${projectId}/request-access`,
        upgrade: () => '/design-software/pricing',
        moveTeam: (projectId: string) => `/projects/${projectId}/move-team`,
    },

    isEditorPath: (path?: string | null) => !!path && /^\/projects\/[^/]+\/editor(?:$|[/?#])/.test(path),

    id: {
        generate: (project: Section, design?: Section, diagram?: Section) => {
            const parts = [];

            if (typeof project === 'string') {
                parts.push(project);
            } else {
                parts.push(project.slug || project.id);
            }

            if (typeof design === 'string') {
                parts.push(design);
            } else if (typeof design === 'object') {
                parts.push(design.slug || design.id);
            }

            if (typeof diagram === 'string') {
                parts.push(diagram);
            } else if (typeof diagram === 'object') {
                parts.push(diagram.slug || diagram.id);
            }

            return parts.join(':');
        },
        parse: (ids: string) => {
            return ids.split(':');
        },
    },
} as const;

export { ProjectHelpers };
